<template>
  <a :href="link.url" class="card">
    <Media :images="link.images" class="card__media" />
    <div
      class="card__title"
      :class="{ 'card__title--highlight': highlightTitles }"
    >
      <span>{{ link.title }}</span>
    </div>
  </a>
</template>

<script>
import Media from "@/components/Media.vue";

export default {
  name: "SearchCard",
  components: {
    Media,
  },
  props: {
    link: {
      type: Object,
      required: true,
    },
    highlightTitles: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  width: 260px;
  text-decoration: none;

  &__title {
    margin-top: 12px;
    @include editorial-body(14px);
    text-align: left;
    font-style: italic;
    &--highlight {
      color: $color-red;
    }
  }

  &__media {
    aspect-ratio: 2/3;
  }
}
</style>
